import { Typography } from '@euler/app/components/typography';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { updateCheckingLogs$ } from '@euler/functions/useCheckForUpdates';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { formatDateTime } from '@euler/utils/formatters';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { ScrollView, Text, View } from 'react-native';

export const DebugPanel = wrapNavigatorScreen(
  () => {
    const { rpx } = useResponsiveContext();
    const [updateLogs] = useBehaviorSubject(updateCheckingLogs$);
    return (
      <ScrollView
        contentContainerStyle={{
          padding: rpx(15),
        }}
      >
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Medium};
            font-size: ${rpx(14)}px;
            color: #444;
            line-height: ${rpx(20)}px;
            margin-bottom: ${rpx(10)}px;
          `}
        >
          Updates Checking Logs
        </Text>
        {updateLogs.map(log => (
          <View
            key={log.id}
            css={`
              border-bottom-width: 0.5px;
              border-bottom-color: #eee;
              padding: ${rpx(4)}px 0;
            `}
          >
            <Typography.Label
              light
              size={rpx(12)}
              color="#444"
            >{`[${formatDateTime(log.timestamp, 'HH:mm:ss')}]${
              log.message
            }`}</Typography.Label>
          </View>
        ))}
      </ScrollView>
    );
  },
  {
    title: 'Debug Panel',
    cardStyle: {
      backgroundColor: '#fff',
    },
  },
);
